import { ReactElement } from "react";
import { FormField } from "@justworkshr/milo-form";
import styles from "../../../../SetupFormGenerator.module.css";
import { GeneratedComponentPropWithSet } from "../../../../types";
import { FormPayloadType } from "../../../../../../types";
import { ToggleSwitch } from "pages/employer-of-record/components/ToggleSwitch/ToggleSwitch";

export function ToggleInput<T extends FormPayloadType = FormPayloadType>({
  field,
  accessor,
  touchedField,
  errorField,
  value,
  setFieldValue,
}: GeneratedComponentPropWithSet<T>): ReactElement {
  return (
    <div className={`${errorField && touchedField ? styles.error : ""}`}>
      <FormField
        aria-labelledby="_"
        required={field.required}
        error={errorField && touchedField ? errorField : ""}
      >
        <ToggleSwitch
          checked={value.toString() === "true"}
          disabled={field.disabled ?? false}
          label={field.label}
          onToggleChange={(checked: boolean) => {
            setFieldValue(`setUp.${accessor}`, checked.toString());
          }}
        />
      </FormField>
    </div>
  );
}
